import React, { useEffect, useState } from "react";
import { FaRegTrashAlt } from "react-icons/fa";
import { LuNotebookText } from "react-icons/lu";
import { MdDeliveryDining } from "react-icons/md";
import { GiShoppingBag } from "react-icons/gi";
import { useNavigate } from "react-router-dom";
import emptyCart from "../extras/empty-cart.png";
import Navbar2 from "../component/Navbar2";
import {
  getCart,
  getMe,
  increaseQuantity,
  decreaseQuantity,
  removeCartItem,
  placeOrder,
} from "../api/axios";
import { toast } from "react-toastify";

const Cart = ({ location, getLocation }) => {
  const navigate = useNavigate();
  const [data, setData] = useState();
  const [cartItem, setCartItem] = useState();
  const [pageLoading, setPageLoading] = useState(true); // initial load
  const [updatingItemId, setUpdatingItemId] = useState(null); // +/- per item
  const [placingOrder, setPlacingOrder] = useState(false);

  const [address, setAddress] = useState({
    fullName: "",
    street: "",
    state: "",
    postcode: "",
    country: "",
    phone: "",
  });

  useEffect(() => {
    const loadCart = async () => {
      setPageLoading(true);
      try {
        const user = await getMe();

        const cart = await getCart(user.id);
        setData(cart);
        setCartItem(cart.items);
      } catch (err) {
        toast.error("Failed to load cart");
      } finally {
        setPageLoading(false);
      }
    };

    loadCart();
  }, []);

  const handleCheckOut = async (e) => {
    if (!address.street?.trim() || !address.postcode?.trim()) {
      toast.error("Street and Postcode are required");
      return;
    }
    e.preventDefault();
    try {
       setPlacingOrder(true);

       await placeOrder({
        address: `
          ${address.fullName},
          ${address.street},
          ${address.state},
          ${address.postcode},
          ${address.country},
          Phone: ${address.phone}
        `,
        paymentMethod: "COD",
      });

      toast.success("Order Placed SuccesFully");
    } catch (err) {
      console.error(err);
      toast.error("failed to place order");
    } finally {
       setPlacingOrder(false);
    }
    
  };

  const totalPrice = data?.totalPrice ?? 0;
  const handleIncrease = async (item) => {
    setUpdatingItemId(item.id);

    // optimistic update
    setCartItem((prev) =>
      prev.map((i) =>
        i.id === item.id ? { ...i, quantity: i.quantity + 1 } : i
      )
    );

    try {
      const res = await increaseQuantity(item.id);
      setCartItem(res.data.items);
      setData(res.data);
    } catch (err) {
      toast.error("Failed to update quantity");
    } finally {
      setUpdatingItemId(null);
    }
  };
  const handleDecrease = async (item) => {
    if (item.quantity <= 1) return;

    setUpdatingItemId(item.id);

    setCartItem((prev) =>
      prev.map((i) =>
        i.id === item.id ? { ...i, quantity: i.quantity - 1 } : i
      )
    );

    try {
      const res = await decreaseQuantity(item.id);
      setCartItem(res.data.items);
      setData(res.data);
    } catch (err) {
      toast.error("Failed to update quantity");
    } finally {
      setUpdatingItemId(null);
    }
  };
  const handleRemove = async (itemId) => {
  setUpdatingItemId(itemId);

  try {
    const res = await removeCartItem(itemId);
    setData(res.data);
    setCartItem(res.data.items);
  } catch (err) {
    toast.error("Failed to remove item");
  } finally {
    setUpdatingItemId(null);
  }
};


  return (
    <>
      <Navbar2 />
      <div className="mt-10 max-w-6xl mx-auto mb-5 px-4 md:px-0">
        {pageLoading ? (
          <div className="text-center py-20 text-gray-500">
            Loading your cart...
          </div>
        ) : cartItem?.length > 0 ? (
          <div>
            <h1 className="font-bold text-2xl ">
              My Cart ({cartItem?.length})
            </h1>
            <div>
              <div className="mt-10">
                {cartItem.map((item, index) => {
                  return (
                    <div
                      key={item.id}
                      className="bg-gray-100 p-5 rounded-md flex items-center justify-between mt-3 w-full"
                    >
                      <div className="flex items-center gap-4">
                        <img
                          src={item.product.imgLink}
                          alt={item.product.product_name}
                          className="w-20 h-20 rounded-md"
                        />
                        <div>
                          <h1 className="md:w-[300px] line-clamp-2 ">
                            {item.product.product_name}
                          </h1>
                          <p className="text-red-500 font-semibold text-lg">
                            ${item.product.product_price}
                          </p>
                        </div>
                      </div>
                      <div className="bg-red-500 text-white flex gap-4 p-2 rounded-md font-bold text-xl">
                        <button
                          onClick={() => handleDecrease(item)}
                          disabled={
                            updatingItemId === item.id || item.quantity <= 1
                          }
                          className="cursor-pointer"
                        >
                          -
                        </button>
                        <span>{item.quantity}</span>
                        <button
                          onClick={() => handleIncrease(item)}
                          disabled={updatingItemId === item.id}
                          className="cursor-pointer"
                        >
                          +
                        </button>
                      </div>
                      <span
                       onClick={() => handleRemove(item.id)}
                        className="hover:bg-white/60 transition-all rounded-full p-3 hover:shadow-2xl"
                      >
                        <FaRegTrashAlt className="text-red-500 text-2xl cursor-pointer" />
                      </span>
                    </div>
                  );
                })}
              </div>
              <div className="grid grid-cols-1 md:grid-cols-2 md:gap-20">
                <div className="bg-gray-100 rounded-md p-7 mt-4 space-y-2">
                  <h1 className="text-gray-800 font-bold text-xl">
                    Delivery Info
                  </h1>
                  <div className="flex flex-col space-y-1">
                    <label htmlFor="">Full Name</label>
                    <input
                      type="text"
                      placeholder="Enter your name"
                      className="p-2 rounded-md"
                      value={address.fullName}
                      onChange={(e) =>
                        setAddress({ ...address, fullName: e.target.value })
                      }
                    />
                  </div>
                  <div className="flex flex-col space-y-1">
                    <label htmlFor="">Address</label>
                    <input
                      type="text"
                      placeholder="Enter your address"
                      className="p-2 rounded-md"
                      value={address?.street}
                      onChange={(e) =>
                        setAddress({ ...address, street: e.target.value })
                      }
                    />
                  </div>
                  <div className="flex w-full gap-5">
                    <div className="flex flex-col space-y-1 w-full">
                      <label htmlFor="">State</label>
                      <input
                        type="text"
                        placeholder="Enter your state"
                        className="p-2 rounded-md w-full"
                        value={address?.state}
                        onChange={(e) =>
                          setAddress({ ...address, state: e.target.value })
                        }
                      />
                    </div>
                    <div className="flex flex-col space-y-1 w-full">
                      <label htmlFor="">PostCode</label>
                      <input
                        type="text"
                        placeholder="Enter your postcode"
                        className="p-2 rounded-md w-full"
                        value={address?.postcode}
                        onChange={(e) =>
                          setAddress({ ...address, postcode: e.target.value })
                        }
                      />
                    </div>
                  </div>
                  <div className="flex w-full gap-5">
                    <div className="flex flex-col space-y-1 w-full">
                      <label htmlFor="">Country</label>
                      <input
                        required
                        type="text"
                        placeholder="Enter your country"
                        className="p-2 rounded-md w-full"
                        value={address?.country}
                        onChange={(e) =>
                          setAddress({ ...address, country: e.target.value })
                        }
                      />
                    </div>
                    <div className="flex flex-col space-y-1 w-full">
                      <label htmlFor="">Phone No</label>
                      <input
                        required
                        type="text"
                        placeholder="Enter your Number"
                        className="p-2 rounded-md w-full"
                        onChange={(e) =>
                          setAddress({ ...address, phone: e.target.value })
                        }
                      />
                    </div>
                  </div>
                  <button className="bg-red-500 text-white px-3 py-1 rounded-md mt-3 cursor-pointer">
                    Submit
                  </button>
                  <div className="flex items-center justify-center w-full text-gray-700">
                    ---------OR-----------
                  </div>
                  <div className="flex justify-center">
                    <button
                      onClick={getLocation}
                      className="bg-red-500 text-white px-3 py-2 rounded-md"
                    >
                      Detect Location
                    </button>
                  </div>
                </div>
                <div className="bg-white border border-gray-100 shadow-xl rounded-md p-7 mt-4 space-y-2 h-max">
                  <h1 className="text-gray-800 font-bold text-xl">
                    Bill details
                  </h1>
                  <div className="flex justify-between items-center">
                    <h1 className="flex gap-1 items-center text-gray-700">
                      <span>
                        <LuNotebookText />
                      </span>
                      Items total
                    </h1>
                    <p>${totalPrice}</p>
                  </div>
                  <div className="flex justify-between items-center">
                    <h1 className="flex gap-1 items-center text-gray-700">
                      <span>
                        <MdDeliveryDining />
                      </span>
                      Delivery Charge
                    </h1>
                    <p className="text-red-500 font-semibold">
                      <span className="text-gray-600 line-through"> ₹25</span>{" "}
                      FREE
                    </p>
                  </div>
                  <div className="flex justify-between items-center">
                    <h1 className="flex gap-1 items-center text-gray-700">
                      <span>
                        <GiShoppingBag />
                      </span>
                      Handling Charge
                    </h1>
                    <p className="text-red-500 font-semibold"> ₹5</p>
                  </div>
                  <hr className="text-gray-200 mt-2" />
                  <div className="flex justify-between items-center">
                    <h1 className="font-semibold text-lg">Grand total</h1>
                    <p className="font-semibold text-lg"> ₹{totalPrice + 5}</p>
                  </div>
                  <div>
                    <h1 className="font-semibold text-gray-700 mb-3 mt-7">
                      Apply Promo Code
                    </h1>
                    <div className="flex gap-3">
                      <input
                        type="text"
                        placeholder="Enter code"
                        className="p-2 rounded-md w-full"
                      />
                      <button className="bg-white text-black border border-gray-200 px-4 cursor-pointer py-1 rounded-md">
                        Apply
                      </button>
                    </div>
                  </div>
                  <button
                    onClick={handleCheckOut}
                      disabled={placingOrder}
                     className={`bg-red-500 text-white px-3 py-2 rounded-md w-full mt-3
    ${placingOrder ? "opacity-50 cursor-not-allowed" : ""}`}
                  >
                      {placingOrder ? "Placing order..." : "Proceed to Checkout"}
                  </button>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div className="flex flex-col gap-3 justify-center items-center h-[600px]">
            <h1 className="text-red-500/80 font-bold text-5xl text-muted">
              Oh no! Your cart is empty
            </h1>
            <img src={emptyCart} alt="" className="w-[400px]" />
            <button
              onClick={() => navigate("/products")}
              className="bg-red-500 text-white px-3 py-2 rounded-md cursor-pointer "
            >
              Continue Shopping
            </button>
          </div>
        )}
      </div>
    </>
  );
};

export default Cart;
